import React, { useState, useEffect } from "react";

export default function CarouselItem({ url, title, description, link, alt, queue, bar, fullscreen, handleSwipe }) {
  const [progress, setProgress] = useState("carousel-bar-filled");

  useEffect(() => {
    setProgress("");
    setProgress("carousel-bar-filled");
  }, [queue]);

  const [seconds, setSeconds] = useState(1);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setSeconds((prevSeconds) => prevSeconds + 1);
    }, 1000);

    return () => clearInterval(intervalId); // Limpiar el intervalo al desmontar el componente
  }, []); //

  return (
    <div className="carousel-item"  onTouchStart={handleSwipe} onMouseDown={handleSwipe}>
      {bar ? (
        <div className="carousel-bar">
          {" "}
          <span className="carousel-bar-filled"></span>{" "}
        </div>
      ) : (
        <></>
      )}
      {url && (
        <>
              {url.url.includes("mp4") ? (
        <video className={`carousel-img ${fullscreen ? "carousel-img-fullscreen" : ""}`} alt={alt} controls>
          <source src={url.url} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      ) : (
        <img className={`carousel-img ${fullscreen ? "carousel-img-fullscreen" : ""}`} src={url.url} alt={alt} />
      )}
        </>
      )}
      {title || description ? (
        <div className="carousel-text-cont">
          {title ? <p className="carousel-item-title">{title}</p> : <></>}
          {description ? (
            <p className="carousel-item-description">{description}</p>
          ) : (
            <></>
          )}
        </div>
      ) : (
        <></>
      )}

      {/* <p className='carousel-seconds'> {seconds} </p> */}
    </div>
  );
}
